import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {BruteForceSymbol, BruteForceSymbolStates} from "../reels/BruteForceSymbol";
import {BruteForceSound} from "../sound/BruteForceSound";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {BruteForceXNudgeSymbol} from "../reels/BruteForceXNudgeSymbol";


export class BruteForceNormalBetPresentation implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                flowStateController.finish();
            }
        });
        // const delay = BruteForceReelsArea.stepDuration;
        BruteForce.betlineView.reset();
        for (let j: number = 0; j < 5; j++) {
            BruteForce.allreelsView.reelModels[j].updateBetlineSymbolPosition(j);

        }
        BruteForce.reelOverlayView.resetViewPosition();
        if (BruteForce.totalWinView.isWinShowing) {
            BruteForce.totalWinView.hide();
        }
        if (BruteForce.model.nextMode !== BruteForceGameMode.FREESPIN_SUPER) {
            BruteForce.gameContainer.resetNudgeMultiplier();
        }

        BruteForce.allreelsView.reelModels.forEach((reelModel: SimpleReelModel, reelNo: number) => {

            reelModel.symbols.forEach((item, symNo: number) => {
                tl.add((<BruteForceSymbol>item.positionable).setState(BruteForceSymbolStates.NORMAL).timeScale(2), 0); //#81
            })
        });
        BruteForce.miniPayTable.onNewBet();
        BruteForce.allreelsView.reelModels.forEach((reel: SimpleReelModel) => {
            reel.setInteractiveSymbols(false);
        });
        BruteForce.foregroundElements.setInteractiveButton(false);
        flowStateController.setSkipCallback();

        tl.to(this, {duration: 0.2}, ">");
        tl.addLabel("reelStart");
        BruteForceSound.playTrack(BruteForceSound.REELS_SPINNING, 1, Number.MAX_VALUE);
        for (let reelID: number = 0; reelID < 5; reelID++) {
            tl.add(BruteForce.allreelsView.reelModels[reelID].start(false), "reelStart");
            if (BruteForce.model.mode === BruteForceGameMode.FREESPIN_SUPER && BruteForce.model.nextMode === BruteForceGameMode.FREESPIN_SUPER) {
                BruteForce.allreelsView.reelModels[reelID].stickySymbolLayerUp(<BruteForceXNudgeSymbol>BruteForce.allreelsView.reelModels[reelID].getStopSymbolAt(0));
            }
        }
    }
}